import React, { useRef } from "react";
import styled, { ThemeProvider, css } from "styled-components";
import NavBar from "./components/NavBar";
// import { useSelector, shallowEqual, useDispatch } from "react-redux";
import useSize from "./hooks/useSize";
// import Login from "./components/Login";
// import settings from "./settings/demo";
import { getClientProps } from "./utils";
// import { updateIsLoggedIn } from "./slices";
import theme from "./themes";

import get from "lodash/get";

// const { username, password } = settings;

const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  background-color: ${({ theme }) => theme.colors.mainBgColor};
  background-image: ${({ theme }) => theme.backgroundImage};
  background-repeat: repeat-x;
  background-size: cover;
  background-attachment: fixed;
  min-height: 100vh;
`;

const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 4;
`;

const Header = styled.div`
  height: 80px;
  background: #1a1c1d;
  padding: 15px 30px 0;
  border-bottom: 3px solid #e5e5e5;
  display: flex;
  align-items: center;
  color: #e5e5e5;
  font-weight: 600;
  font-size: 23px;

  ${({ theme }) =>
    theme.screenWidth < 700 &&
    css`
      padding-left: 15px;
    `}

  ${({ theme }) =>
    theme.screenWidth < 600 &&
    css`
      height: 40px;
      font-size: 17px;
    `}
`;

const Logo = styled.div`
  background-image: url("/images/playradar_logo.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 300px;
  height: 100%;
  margin: 0 13px 0 0;

  ${({ theme }) =>
    theme.screenWidth < 600 &&
    css`
      margin: 0 10px 0 0;
      width: 200px;
    `}
`;

const App = () => {
  const target = useRef(null);
  const size = useSize(target);
  const screenWidth = get(size, "width");
  // const dispatch = useDispatch();

  const appTheme = {
    ...theme,
    screenWidth,
  };

  // const userIsLoggedIn = useSelector(
  //   (state) => state.user.isLoggedIn,
  //   shallowEqual
  // );

  // useEffect(() => {
  //   const handleMessage = (e) => {
  //     const { authCredentials } = e.data;
  //     if (authCredentials) {
  //       const isValidCredentials =
  //         authCredentials.username === username &&
  //         authCredentials.password === password;

  //       if (isValidCredentials) {
  //         dispatch(updateIsLoggedIn(true));
  //       }
  //     }
  //   };

  //   window.addEventListener("message", handleMessage, false);
  //   return () => window.removeEventListener("message", handleMessage, false);
  // }, [dispatch]);

  // const content = userIsLoggedIn ? <vaix-carousel-widget /> : <Login />;

  const { clientName } = getClientProps();

  return (
    <div ref={target}>
      <ThemeProvider theme={appTheme}>
        <Wrapper>
          {clientName === "demo" ? (
            <HeaderWrapper data-test="header-wrapper">
              <Header>
                <Logo />
                Casino Personalization
              </Header>
              {/* {userIsLoggedIn ? <NavBar screenWidth={screenWidth} /> : null} */}
              <NavBar screenWidth={screenWidth} />
            </HeaderWrapper>
          ) : null}
          <vaix-smart-search-widget id="demo-smart-search" />
          <vaix-carousel-widget
            id="demo-carousel-widget"
            key="demo-carousel-widget"
          />
        </Wrapper>
      </ThemeProvider>
    </div>
  );
};

export default App;
